export default __webpack_public_path__ + "static/media/avatar-7.81ae8bca.jpg";